module.exports = __webpack_public_path__ + "img/ai.efc44f67.png";